import React, { useLayoutEffect } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

am4core.useTheme(am4themes_animated);

const TotalFirstMentionAwarenessChart = ({ selectedProvince, selectedLocalMarket, data }) => {
  useLayoutEffect(() => {
    let chart = am4core.create('total-first-mention-awareness', am4charts.XYChart);  
    chart.logo.disabled = true;
   
    chart.data = data;       

    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'Year';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.minGridDistance = 30;
    categoryAxis.renderer.line.disabled = true;
    categoryAxis.renderer.labels.template.dy = -120; // Moves the year labels closer to the chart
    categoryAxis.numberFormatter = new am4core.NumberFormatter();
    categoryAxis.numberFormatter.numberFormat = "#"; 

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.labels.template.disabled = true;
    valueAxis.min = -10;
    valueAxis.extraMax = 0.1;
    valueAxis.strictMinMax = false;

    const bankNames = ['Absa', 'Capitec', 'FNB', 'Nedbank', 'Standard Bank', 'TymeBank'];
    let colors = [am4core.color('#C8102E'), am4core.color('#E75480'), am4core.color('#003876'), am4core.color('#005941'), am4core.color('#0473EA'), am4core.color('#f4ca16')];

    bankNames.forEach((bank, index) => {
      let series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = bank;
      series.dataFields.categoryX = 'Year';
      series.name = bank;
      series.strokeWidth = 1.7;
      series.tensionX = 0.8;
      series.stroke = colors[index];
      series.tooltipText = '{name}: [bold]{valueY}[/]';

          
      series.tooltip.getFillFromObject = false; 
      series.tooltip.background.fill = colors[index]; 
      series.tooltip.label.fill = am4core.color('#FFFFFF'); 

      let boxBullet = series.bullets.push(new am4charts.Bullet());
      let roundedRectangle = boxBullet.createChild(am4core.RoundedRectangle);
      roundedRectangle.width = 35;
      roundedRectangle.height = 35;
      roundedRectangle.fill = colors[index];
      roundedRectangle.stroke = series.stroke;
      roundedRectangle.strokeWidth = 1;
      roundedRectangle.horizontalCenter = 'middle';
      roundedRectangle.verticalCenter = 'middle';
      roundedRectangle.cornerRadius(4, 5, 5, 4);

      let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = '{valueY}';
      labelBullet.label.fill = am4core.color('#FFF');
      labelBullet.label.fontSize = 17;
      labelBullet.label.fontWeight = '500';
      labelBullet.label.horizontalCenter = 'middle';
      labelBullet.label.verticalCenter = 'middle';
      labelBullet.label.adapter.add('y', (y, target) => -roundedRectangle.height / 2 + 17);
    });
   
    

    chart.events.on("datavalidated", function() {    //An event listener allowing to execute a function when a specific event occurs on the chart
      let sb_direction = chart.data[9];  
      chart.data.forEach((item, index) => {
        if (index === chart.data.length - 1){
          return
        }
        let label = chart.plotContainer.createChild(am4core.Label);
        label.text = `${item['Standard Bank Rank']}`; 
        label.fontSize = 20;
        label.fontWeight = 'bold';
        label.fill = am4core.color('#0473EA'); // 
        label.align = 'center';
        label.isMeasured = false;
        label.x = categoryAxis.categoryToPoint(item['Year']).x - label.measuredWidth / 2;
        label.y = -20; 

        if (index === chart.data.length - 2){
          if (sb_direction['sb_up'] == 'Down'){
            label.background.fill = am4core.color('#FF0000'); // Red
          }   
          else if (sb_direction['sb_up'] == 'Up'){
            label.background.fill = am4core.color('#00ff00'); // Green          
          }          
          else {
            label.background.fill = am4core.color('#ffffff'); // White
          }          
        }   
      });
    });

    chart.legend = new am4charts.Legend();
    chart.legend.position = 'bottom';
    chart.legend.marginTop = -100; // Moves legend closer to the chart
    chart.legend.itemContainers.template.paddingRight = 5; // Adds space between legend markers and names
    chart.legend.itemContainers.template.paddingLeft = 20;
    chart.legend.labels.template.paddingLeft = 5; 

    chart.cursor = new am4charts.XYCursor();

    return () => chart.dispose();
  }, [data]);

  return <div id="total-first-mention-awareness" style={{ width: '100%', height: '600px' }}></div>;
};

export default TotalFirstMentionAwarenessChart;

